export const isLocationFormatValid = (value: string) => {
  if (value.split(",").length !== 2) {
    return false;
  }
  if (
    isNaN(Number(value.split(",")[0])) ||
    isNaN(Number(value.split(",")[1]))
  ) {
    return false;
  }
  return true;
};
